import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {ProofTermsBeforeBeginPage} from './proof-terms-before-begin';

@NgModule({
  declarations: [
    ProofTermsBeforeBeginPage,
  ],
  imports: [
    IonicPageModule.forChild(ProofTermsBeforeBeginPage),
  ],
  exports: [
    ProofTermsBeforeBeginPage
  ]
})
export class ProofTermsBeforeBeginPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/proof-terms-before-begin/proof-terms-before-begin.module.ts